import { TextField, Typography } from "@mui/material";
import { useState } from "react";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { BlModal } from "Shared/Dialogs/BlModal";

interface RejectWithdrawalDialogProps {
  isOpen: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

export const RejectWithdrawalDialog = ({
  isOpen,
  isLoading,
  onCancel,
  onConfirm,
}: RejectWithdrawalDialogProps): React.ReactNode => {
  const { t } = useResource();
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirm(reason);
  };

  const handleCancel = () => {
    setReason("");
    onCancel();
  };

  return (
    <BlModal
      isOpen={isOpen}
      title={t(Resources.WithdrawalApprovals.Reject)}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      cancelButtonText={t(Resources.Common.Cancel)}
      confirmButtonText={t(Resources.WithdrawalApprovals.ConfirmReject)}
      isLoading={isLoading}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: Spacing.XS }}
      >
        {t(Resources.WithdrawalApprovals.RejectionReason)}
      </Typography>
      <TextField
        fullWidth
        multiline
        minRows={3}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder={t(
          Resources.WithdrawalApprovals.RejectionReasonPlaceholder,
        )}
      />
    </BlModal>
  );
};
